import React from 'react';
import axios from '../axios';
import ModalAlert from '../redux/components/modal/modal_alert';
import ModalConfirm from '../redux/components/modal/modal_confirm';
import ModalLoader from '../modal/modal_loader';
import moment from 'moment';
import EventGuide from './event_guide';
// import SectionCashbackshops from './section_cashback_shops';
import SectionImage from './section_image';
import SectionPlans from './section_plans';
import SectionDate from './section_date';
import SectionPlace from './section_place';
import SectionNumOfPeople from './section_num_of_people';
import SectionCircle from './section_circle';
import SectionIsMultiplePurchase from './section_is_multiple_purchase';
import SectionIsGenderManaged from './section_is_gender_managed';
import SectionIsAgeLimited from './section_is_age_limited';
import SectionRecruitUnified from './section_recruit_unified';
import SectionYoutube from './section_youtube';
import {
  ModalContentForDetail,
  SectionOnline,
  SectionUrl,
} from './section_detail';
import { countRequiredRemaining } from './required_remaining';
import { isPublishableTitle, titleLengthError } from './title_limits';
import { onlineUrlError as getOnlineUrlError } from './online_url';
import { bannerVisible, legacyHistoryButtonVisible } from './entry_logic';
import { isLegacyServiceCircle } from './legacy_event';
import SectionSubject from './section_subject';
import SectionAiButtons from './section_ai_buttons';
import ModalContentBaseXl from '../redux/components/modal/modal_content_base_xl';

const TG = {
  ink: '#333333',
  sub: '#666666',
  muted: '#8B9097',
  line: '#ECECEE',
  primary: '#FF6467',
  wash: '#FFEAEA',
  surface: '#FFFFFF',
};
const TG_CARD_SHADOW =
  '0 1px 2px rgba(30,30,40,.03), 0 10px 26px -16px rgba(30,30,40,.14)';

const SparkleIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M12 2.75c.55 4.45 2.8 6.7 7.25 7.25-4.45.55-6.7 2.8-7.25 7.25-.55-4.45-2.8-6.7-7.25-7.25C9.2 9.45 11.45 7.2 12 2.75Z" fill="currentColor" />
    <path d="M19 15.5c.2 1.65 1.05 2.5 2.7 2.7-1.65.2-2.5 1.05-2.7 2.7-.2-1.65-1.05-2.5-2.7-2.7 1.65-.2 2.5-1.05 2.7-2.7Z" fill="currentColor" />
  </svg>
);

// @context TGW-2195 基本→詳細の2段表示。現在地と行き先をここだけで示す（RN はヘッダーを描かないため本文直下に置く）。
const StepBar = ({ current, setPage }) => {
  const chip = (on) => ({
    background: on ? TG.wash : TG.surface,
    border: `1px solid ${on ? TG.primary : TG.line}`,
    borderRadius: 40,
    padding: '4px 12px',
    fontSize: 12,
    fontWeight: 800,
    color: on ? TG.primary : TG.muted,
    cursor: 'pointer',
  });
  return (
    <div className="container col-md-8 col-lg-6" style={{ paddingTop: 12 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <button type="button" style={chip(current === 1)} onClick={() => setPage('basic')}>
          1 基本
        </button>
        <span style={{ color: TG.muted, fontSize: 14 }}>›</span>
        <button type="button" style={chip(current === 2)} onClick={() => setPage('detail')}>
          2 詳細
        </button>
      </div>
    </div>
  );
};

// @context TGW-2195 基本ページで設定する内容と、写真・動画が任意であることを入力前に伝える。
const BasicHeading = () => (
  <div className="container col-md-8 col-lg-6" style={{ paddingTop: 16, paddingBottom: 4 }}>
    <h1 style={{ margin: 0, fontSize: 22, lineHeight: 1.4, fontWeight: 800, color: TG.ink }}>
      イベントの基本情報
    </h1>
    <p style={{ margin: '6px 0 0', fontSize: 13, lineHeight: 1.6, color: TG.sub }}>
      イベント名と紹介文を確認し、必要なら写真・動画を追加します。
    </p>
  </div>
);

// @context TGW-2195 AI生成とジャンル定型を混同させないよう、既存の由来stateだけで説明を分ける。
const DraftBanner = ({ draftSource, aiSuggested }) => {
  let title = '基本情報を入力しました';
  let description = '内容を確認し、必要なところを編集してください。';

  if (draftSource === 'ai') {
    if (aiSuggested?.title && aiSuggested?.body) {
      title = 'AIがイベント名と紹介文を入力しました';
    } else if (aiSuggested?.title) {
      title = 'AIがイベント名を入力しました';
      description = '紹介文を入力し、イベント名とあわせて確認してください。';
    } else if (aiSuggested?.body) {
      title = 'AIが紹介文を入力しました';
    } else {
      title = 'AIで作成した基本情報を編集しています';
    }
  } else if (draftSource === 'genre') {
    title = '選んだジャンルをもとに基本情報を入力しました';
  }

  return (
    <div className="container col-md-8 col-lg-6" style={{ paddingTop: 8 }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: 11,
          background: TG.wash,
          border: `1px solid ${TG.line}`,
          borderRadius: 16,
          padding: '14px 16px',
        }}
      >
        <span style={{ color: TG.primary, lineHeight: 1.2, flex: 'none' }}>
          <SparkleIcon />
        </span>
        <div>
          <b style={{ display: 'block', fontSize: 13, fontWeight: 800, color: TG.ink }}>
            {title}
          </b>
          <span style={{ fontSize: 12, color: TG.sub, lineHeight: 1.5 }}>
            {description}
          </span>
        </div>
      </div>
    </div>
  );
};

// F3-1 残りの必須項目数。公開ボタンの活性は変えず（判定は validate()）、目安だけを示す
const RemainingCard = ({ n }) => (
  <div className="container col-md-8 col-lg-6" style={{ paddingTop: 8 }}>
    <div
      style={{
        background: TG.surface,
        border: `1px solid ${TG.line}`,
        borderRadius: 16,
        padding: '14px 16px',
        boxShadow: TG_CARD_SHADOW,
      }}
    >
      <div style={{ fontSize: 15, fontWeight: 700, color: TG.ink }}>
        {n === 0 ? '公開できます' : `公開まであと ${n} 項目`}
      </div>
    </div>
  </div>
);

const Main = ({
  props,
  page,
  historyEventId,
  setPage,
  event,
  setEvent,
  eventsPlans,
  setEventsPlans,
  contents,
  setContents,
  bodyText,
  setBodyText,
  titleText,
  setTitleText,
  circle,
  usersCircles,
  setUsersCircles,
  isNewPolicyApplicable,
  reservationSummary,
  onEditReservation,
  setSelectedPlace,
  draftSource,
  aiSuggested,
  clearAiSuggested,
  markAiAccepted,
}) => {
  const [titleError, setTitleError] = React.useState('');
  const [bodyError, setBodyError] = React.useState('');
  const [categoryError, setCategoryError] = React.useState('');
  const [placeError, setPlaceError] = React.useState('');
  const [onlineUrlError, setOnlineUrlError] = React.useState('');
  const [capacityError, setCapacityError] = React.useState('');
  const [dateAlert, setDateAlert] = React.useState('');
  const [eventDateError, setEventDateError] = React.useState('');
  const [circleError, setCircleError] = React.useState('');
  const [modalAlertError, setModalAlertError] = React.useState(
    'イベント作成に失敗しました。時間をおいてもう一度お試しください。'
  );
  // TGW-2466 説明文に貼られた招待URLが通常URLへ変換されたら、完了モーダルで本人に伝える
  const [inviteUrlNotice, setInviteUrlNotice] = React.useState('');
  const [hasPayjp, setHasPayjp] = React.useState(props.myUser.has_payjp);
  const [isDateChangeProhibitionDisplay, setIsDateChangeProhibitionDisplay] =
    React.useState(false);
  const [reservationSummaryState, setReservationSummaryState] =
    React.useState(reservationSummary);
  const isEventEndDatetimeTouched = React.useRef(false);
  const isApplicationDueDateTouched = React.useRef(false);
  const isMeetingDatetimeTouched = React.useRef(false);
  const modalLoaderRef = React.useRef(null);
  const modalAlertSuccessRef = React.useRef(null);
  const modalAlertNewCircleSuccessRef = React.useRef(null);
  const modalAlertDraftSuccessRef = React.useRef(null);
  const modalAlertErrorRef = React.useRef(null);
  const modalAlertValidationErrorRef = React.useRef(null);
  const modalConfirmIsRecruitUnifiedRef = React.useRef(null);
  const modalConfirmSameEventsCreationRef = React.useRef(null);
  const [multiplePurchaseError, setMultiplePurchaseError] = React.useState('');

  const scrollToTop = React.useCallback(() => {
    window.scrollTo({
      top: 0,
      behavior: 'auto',
    });
  }, []);

  const handleEventDateInput = React.useCallback(
    (e) => {
      const target_value = e.target.value;
      if (target_value == null || target_value == '') {
        return;
      }
      if (
        !event.is_new &&
        event.event_date &&
        moment(target_value).format('YYYY/MM/DD') !==
        moment(event.event_date).format('YYYY/MM/DD') &&
        event.regular_participants_count > 0
      ) {
        setIsDateChangeProhibitionDisplay(true);
        setEvent((prev) => ({
          ...prev,
          forceRendarCount: prev.forceRendarCount
            ? prev.forceRendarCount + 1
            : 0,
        })); // 強制的に表示re-rendar
        return;
      }
      // 3週間以上先かどうかで日時アラートを出す
      const twenty_one_days = moment()
        .add(21, 'days')
        .format('YYYY/MM/DD HH:mm');
      const formatted_target_value =
        moment(target_value).format('YYYY/MM/DD HH:mm');
      if (formatted_target_value < twenty_one_days) {
        // 入力値が3週間以内の場合
        setDateAlert('3週間以上先の日時にすることをお勧めします');
      } else {
        setDateAlert('');
      }

      // event_end_datetimeの自動補完
      setEvent((prev) => ({ ...prev, event_date: target_value }));
      if (!isEventEndDatetimeTouched.current) {
        // イベント終了時刻が未編集の場合は自動補完
        const event_end_datetime = moment(target_value)
          .add(2, 'hours')
          .format('YYYY/MM/DD HH:mm');
        setEvent((prev) => ({
          ...prev,
          event_end_datetime: event_end_datetime,
        }));
      } else if (event.event_end_datetime < target_value) {
        setEvent((prev) => ({ ...prev, event_end_datetime: target_value }));
      }

      // application_due_dateの自動補完
      if (
        historyEventId &&
        event.event_date_to_application_due_date_diff_minutes != null
      ) {
        // 過去イベントをコピーしている場合
        const application_due_date = moment(target_value)
          .subtract(event.event_date_to_application_due_date_diff_minutes, 'minutes')
          .format('YYYY/MM/DD HH:mm');
        setEvent((prev) => ({
          ...prev,
          application_due_date: application_due_date,
        }));
      } else if (!isApplicationDueDateTouched.current) {
        // 未編集の場合
        const application_due_date = moment(target_value)
          .subtract(30, 'minutes')
          .format('YYYY/MM/DD HH:mm');
        setEvent((prev) => ({
          ...prev,
          application_due_date: application_due_date,
        }));
      }

      // meeting_datetimeの自動補完
      if (!isMeetingDatetimeTouched.current) {
        // 未編集の場合
        const meeting_datetime = moment(target_value)
          .subtract(5, 'minutes')
          .format('YYYY/MM/DD HH:mm');
        setEvent((prev) => ({ ...prev, meeting_datetime: meeting_datetime }));
      }
    },
    [event, historyEventId]
  );

  // ページを離れるときに警告を出す
  const handleBeforeUnloadEvent = React.useCallback((e) => {
    e.preventDefault();
    e.returnValue =
      !props.isNew && event.is_draft
        ? '現在、このイベントは下書きになっています。公開ボタンを押すまで公開されません。本当にこのページを閉じますか？'
        : '';
  }, []);

  React.useEffect(() => {
    scrollToTop();
    window.addEventListener('beforeunload', handleBeforeUnloadEvent);
    return () =>
      window.removeEventListener('beforeunload', handleBeforeUnloadEvent);
  }, []);

  React.useEffect(() => {
    if (reservationSummary) setReservationSummaryState(reservationSummary);
  }, [reservationSummary]);

  const contentsRef = React.useRef(contents);
  React.useEffect(() => {
    contentsRef.current = contents;
  }, [contents]);

  // @context TGW-2195 E2E で確認: 全画面エディタの「完了」と自動保存が同時に走ると create_content が2連続で飛び、
  //   2本目が 409（説明文の二重作成防止）になって「保存に失敗」の誤警告が出た。作成中はその完了を待って update に回す。
  const creatingTextContentRef = React.useRef(null);
  const updateTextContent = React.useCallback(
    (newBodyText) => {
      const textContent = contentsRef.current.find(
        (content) => content.content_type === 1
      );
      if (textContent && textContent.id) {
        axios
          .post(`/api/event_edit/update_content`, {
            id: textContent.id,
            event_id: event.id,
            body: newBodyText,
          })
          .then((response) => {
            setContents((prev) =>
              prev.map((content) =>
                content.id === textContent.id ? response.data : content
              )
            );
          });
        return;
      }
      if (creatingTextContentRef.current) {
        creatingTextContentRef.current
          .then(() => updateTextContent(newBodyText))
          .catch(() => {});
        return;
      }
      creatingTextContentRef.current = axios
        .post('/api/event_edit/create_content', {
          event_id: event.id,
          body: newBodyText,
          content_type: 1,
        })
        .then((response) => {
          contentsRef.current = [...contentsRef.current, response.data];
          setContents((prev) => [...prev, response.data]);
        })
        .catch(() => {
          setModalAlertError('イベントの説明の保存に失敗しました。もう一度お試しください。');
          modalAlertErrorRef.current.openModal();
        })
        .finally(() => {
          creatingTextContentRef.current = null;
        });
    },
    [event]
  );

  // const updateTitleContent = React.useCallback(
  //   (newTitle) => {
  //     const titleContent = contentsRef.current.find(
  //       (content) => content.content_type === 2
  //     );

  //     if (titleContent && titleContent.id) {
  //       axios
  //         .post(`/api/event_edit/update_content`, {
  //           id: titleContent.id,
  //           event_id: event.id,
  //           body: newTitle,
  //         })
  //         .then((response) => {
  //           setContents((prev) =>
  //             prev.map((content) =>
  //               content.id === titleContent.id ? response.data : content
  //             )
  //           );
  //         });
  //     } else {
  //       axios
  //         .post('/api/event_edit/create_content', {
  //           event_id: event.id,
  //           body: newTitle,
  //           content_type: 2,
  //         })
  //         .then((response) => {
  //           setContents((prev) => [...prev, response.data]);
  //         });
  //     }
  //   },
  //   [event]
  // );

  const performPublic = (isRecruitUnified = null) => {
    window.removeEventListener('beforeunload', handleBeforeUnloadEvent);
    modalLoaderRef.current.openModal();

    // 新規作成サークルだったら更新処理
    if (props.isNewCircle) {
      let circle = props.circle;
      circle.is_new_circle = false;
      circle.is_draft = false;
      const body = JSON.stringify(circle);
      axios.post('/api/circles/update', body);
    }

    // イベント説明更新
    // updateTitleContent(titleText);
    updateTextContent(bodyText);
    const urlParams = new URLSearchParams(window.location.search);
    const normalizedEvent = event;
    const eventData =
      isRecruitUnified != null
        ? {
            ...normalizedEvent,
            title: titleText,
            contents: bodyText,
            is_recruit_unified: isRecruitUnified,
            is_draft: false,
            delete_status: 0,
          }
        : {
            ...normalizedEvent,
            title: titleText,
            contents: bodyText,
            is_draft: false,
            delete_status: 0,
          };
    const parentCircleId = urlParams.get('parent_circle_id');

    const eventBody = JSON.stringify({
      event: eventData,
      parent_circle_id: parentCircleId,
      events_plans: eventsPlans,
      talkroom_id: props.talkroomId,
    });
    axios
      .post('/api/event_edit_submit/public', eventBody)
      .then((response) => {
        console.log(props.canCreateSameEvents);
        setInviteUrlNotice((response.data && response.data.notice) || '');
        if (props.isNewCircle) {
          modalAlertNewCircleSuccessRef.current.openModal();
        } else if (
          props.canCreateSameEvents &&
          !props.circle.company_id &&
          !reservationSummaryState &&
          props.isNew
        ) {
          modalConfirmSameEventsCreationRef.current.openModal();
        } else {
          modalAlertSuccessRef.current.openModal();
        }
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          setModalAlertError((prev) => error.response.data.error || prev);
        }
        modalAlertErrorRef.current.openModal();
      })
      .finally(() => {
        modalLoaderRef.current.closeModal();
      });
  };

  const submitPublic = (e) => {
    e.preventDefault();

    const hasErrors = validate();
    if (hasErrors) {
      scrollToTop();
      setTimeout(() => {
        modalAlertValidationErrorRef.current.openModal();
      }, 200);
      return;
    }

    if (!event.is_recruit_unified) {
      modalConfirmIsRecruitUnifiedRef.current.openModal();
      return;
    }

    performPublic();
  };

  const submitDraft = (e) => {
    e.preventDefault();

    window.removeEventListener('beforeunload', handleBeforeUnloadEvent);
    modalLoaderRef.current.openModal();

    // 新規作成サークルだったら更新処理
    if (props.isNewCircle) {
      let circle = props.circle;
      circle.is_new_circle = false;
      circle.is_draft = false;
      const body = JSON.stringify(circle);
      axios.post('/api/circles/update', body);
    }

    // イベント説明更新
    // updateTitleContent(titleText);
    updateTextContent(bodyText);
    const urlParams = new URLSearchParams(window.location.search);
    const parentCircleId = urlParams.get('parent_circle_id');

    const eventBody = JSON.stringify({
      event: {
        ...event,
        title: titleText,
        contents: bodyText,
        is_draft: true,
        delete_status: 0,
      },
      events_plans: eventsPlans,
      talkroom_id: props.talkroomId,
      parent_circle_id: parentCircleId,
    });

    axios
      .post('/api/event_edit_submit/draft', eventBody)
      .then((response) => {
        modalAlertDraftSuccessRef.current.openModal();
      })
      .catch((error) => {
        if (error.response.data) {
          setModalAlertError((prev) => error.response.data.error || prev);
        }
        modalAlertErrorRef.current.openModal();
      })
      .finally(() => {
        modalLoaderRef.current.closeModal();
      });
  };

  const validate = () => {
    let hasErrors = false;
    if (!isPublishableTitle(titleText)) {
      setTitleError(titleLengthError);
      hasErrors = true;
    } else {
      setTitleError('');
    }
    if (!bodyText) {
      setBodyError('イベントの説明を入力してください。');
      hasErrors = true;
    } else {
      setBodyError('');
    }
    if (!event.is_online && !event.place) {
      setPlaceError('集合場所を入力してください。');
      hasErrors = true;
    } else {
      setPlaceError('');
    }
    const nextOnlineUrlError = getOnlineUrlError({
      isOnline: event.is_online,
      url: event.online_url,
    });
    setOnlineUrlError(nextOnlineUrlError);
    if (nextOnlineUrlError) {
      hasErrors = true;
    }
    if (!event.event_date || !event.event_end_datetime) {
      setEventDateError('イベント日時を入力してください。');
      hasErrors = true;
    } else {
      setEventDateError('');
    }
    if (
      event.application_due_date &&
      event.event_date &&
      moment(event.application_due_date).isAfter(moment(event.event_date))
    ) {
      setEventDateError(
        '募集締め切りはイベント開始時刻より前に設定してください。'
      );
      hasErrors = true;
    }
    if (
      event.min_num_of_people &&
      event.capacity &&
      event.min_num_of_people > event.capacity
    ) {
      setCapacityError(
        '最大人数は、最小人数を上回るよう設定してください。'
      );
      hasErrors = true;
    } else {
      setCapacityError('');
    }
    if (!event.circle_id) {
      setCircleError('サークルを選択または作成してください。');
      hasErrors = true;
    } else {
      setCircleError('');
    }
    if (reservationSummaryState) {
      const StartWithinEvent =
        moment(event.event_date) <= moment(reservationSummaryState.start_at);
      const EndWithinEvent =
        moment(event.event_end_datetime) >=
        moment(reservationSummaryState.end_at);
      if (!(StartWithinEvent && EndWithinEvent)) {
        setEventDateError('イベントの日時と会場予約の日時を合わせてください。');
        hasErrors = true;
      }
    }
    if (props.isNew && event.is_multiple_purchase_allowed && (event.is_gender_managed || event.is_age_limited)) {
      setMultiplePurchaseError(
        '男女比調整または年齢制限が設定されている場合は、友達分のチケット購入は設定できません。'
      );
      hasErrors = true;
    } else {
      setMultiplePurchaseError('');
    }
    return hasErrors;
  };

  // validationエラーの解消
  React.useEffect(() => {
    if (isPublishableTitle(titleText)) {
      setTitleError('');
    }
    if (event.place) {
      setPlaceError('');
    }
    if (!getOnlineUrlError({ isOnline: event.is_online, url: event.online_url })) {
      setOnlineUrlError('');
    }
    if (bodyText) {
      setBodyError('');
    }
    if (
      event.min_num_of_people &&
      event.capacity &&
      event.min_num_of_people <= event.capacity
    ) {
      setCapacityError('');
    }
    if (!!event.event_date && !!event.event_end_datetime) {
      const applicationDueAfterStart =
        event.application_due_date &&
        moment(event.application_due_date).isAfter(moment(event.event_date));
      if (!applicationDueAfterStart) {
        setEventDateError('');
      }
    }
    if (event.circle_id) {
      setCircleError('');
    }
  }, [event, titleText, bodyText]);

  // 募集締め切りがイベント開始時刻より後のときエラーを表示
  React.useEffect(() => {
    if (
      event.application_due_date &&
      event.event_date &&
      moment(event.application_due_date).isAfter(moment(event.event_date))
    ) {
      setEventDateError(
        '募集締め切りはイベント開始時刻より前に設定してください。'
      );
    }
  }, [event.application_due_date, event.event_date]);

  // React.useEffect(() => {
  //   if (!props.isNew && !event.is_draft) {
  //     const eventBody = JSON.stringify({
  //       event: { ...event, is_draft: true, delete_status: 0 },
  //       events_plans: eventsPlans,
  //       talkroom_id: props.talkroomId,
  //     });
  //     axios
  //       .post('/api/event_edit_submit/draft', eventBody)
  //       .then((response) => {
  //         modalAlertDraftCautionRef.current.openModal();
  //       })
  //       .catch((error) => {
  //         if (error.response.data) {
  //           setModalAlertError((prev) => error.response.data.error || prev);
  //         }
  //         modalAlertErrorRef.current.openModal();
  //       });
  //   }
  // }, []);

  const toTipForSuccess = React.useCallback(() => {
    modalAlertSuccessRef.current.closeModal();
    modalAlertNewCircleSuccessRef.current.closeModal();
    modalConfirmSameEventsCreationRef.current.closeModal();
    modalAlertDraftSuccessRef.current.closeModal();
    modalAlertErrorRef.current.closeModal();
    window.location.href = `/event/${event.id}/tips_for_success`;
  }, []);

  const toEventPage = React.useCallback(() => {
    modalAlertSuccessRef.current.closeModal();
    modalAlertNewCircleSuccessRef.current.closeModal();
    modalConfirmSameEventsCreationRef.current.closeModal();
    modalAlertDraftSuccessRef.current.closeModal();
    modalAlertErrorRef.current.closeModal();
    // @context TGW-2195 /events/new では props.circle が空のまま、主催サークルは event.circle_id にだけ入る。
    //   props.circle.id だけを見ると /circle//events/:id へ遷移するため、選択後の値を優先する（PR #2536 Copilot 指摘）。
    const circleId = event.circle_id || props.circle.id;
    if (props.circle.company_id) {
      window.location.href =
        '/community/' +
        props.circle.company.id_to_param +
        '/circle/' +
        circleId +
        '/events/' +
        event.id;
    } else {
      window.location.href = '/circle/' + circleId + '/events/' + event.id;
    }
  }, [event.circle_id, event.id]);

  const toSameEventsCreationPage = () => {
    modalAlertSuccessRef.current.closeModal();
    modalAlertNewCircleSuccessRef.current.closeModal();
    modalConfirmSameEventsCreationRef.current.closeModal();
    modalAlertDraftSuccessRef.current.closeModal();
    modalAlertErrorRef.current.closeModal();
    window.location.href = '/event/edit/' + event.id + '/same_events_creation';
  };

  const HistoryEventBtn = React.useCallback(
    () => (
      <div className="w-100 bg-white">
        <div className="container col-md-8 col-lg-6 p-0">
          <div className="d-flex justify-content-end">
            {/* @context TGW-2677 文字が小さくイベント名カードに詰まって見えたため、14px に上げ上下に余白を取る（押せる範囲も広げる）。 */}
            <button
              className="bg-white border-0 mr-2 text-fz-14px text-gray text-fw-normal"
              style={{ padding: '20px 4px 16px' }}
              onClick={() => {
                setPage(1);
              }}
            >
              <span style={{ textDecoration: 'underline' }}>
                過去のイベントのコピーでつくる
              </span>
            </button>
          </div>
        </div>
      </div>
    ),
    [setPage],
  );

  const onFocusScrollForAndroid = (event) => {
    if (props.userAgent === 'android' && window) {
      const rect = event.target.getBoundingClientRect();
      window.scrollTo({
        top: rect.top + window.scrollY - 30,
        behavior: 'smooth',
      });
    }
  };
  const hasSpaceReservation = !!reservationSummaryState;
  const [modalPageUrl, setModalPageUrl] = React.useState(null);
  const articleModalRef = React.useRef(null);

  const [detailOpen, setDetailOpen] = React.useState(false);
  const detailScrollY = React.useRef(0);
  const openDetail = () => {
    detailScrollY.current = window.scrollY || window.pageYOffset || 0;
    setDetailOpen(true);
  };
  const closeDetail = () => {
    setDetailOpen(false);
    requestAnimationFrame(() => window.scrollTo(0, detailScrollY.current));
  };

  // @context TGW-2195 page で描く section を出し分ける（詳細設計 §3.7）。
  //   state・validate()・保存処理・自動補完は変更しない。フラグ OFF（page 0）は従来の1本フォームのまま。
  const isBasic = page === 'basic';
  const isDetail = page === 'detail';
  const remainingCount = countRequiredRemaining({ event, eventsPlans });

  const aiButtonsBlock = (
    <SectionAiButtons
      titleText={titleText}
      bodyText={bodyText}
      setTitleText={setTitleText}
      setBodyText={setBodyText}
      event={event}
      setEvent={setEvent}
      contents={contents}
      setContents={setContents}
      // updateTitleContent={updateTitleContent}
      updateTextContent={updateTextContent}
      markAiAccepted={markAiAccepted}
    />
  );
  const subjectBlock = (
    <SectionSubject
      event={event}
      setEvent={setEvent}
      bodyText={bodyText}
      titleText={titleText}
      setBodyText={setBodyText}
      setTitleText={setTitleText}
      categoryError={categoryError}
      setCategoryError={setCategoryError}
      servicesCategories={props.servicesCategories}
      bodyError={bodyError}
      titleError={titleError}
      setTitleError={setTitleError}
      // updateTitleContent={updateTitleContent}
      updateTextContent={updateTextContent}
      onFocusScrollForAndroid={onFocusScrollForAndroid}
      userAgent={props.userAgent}
      aiSuggested={aiSuggested}
      clearAiSuggested={clearAiSuggested}
    />
  );
  const imageBlock = (
    <SectionImage
      eventId={event.id}
      mainImageUrl={event.main_image_url_medium_strict || ''}
      setMainImageUrl={(url) =>
        setEvent((prev) => ({ ...prev, main_image_url_medium_strict: url }))
      }
      subImages={
        contents
          .filter(
            (content) =>
              content.content_type === 3 && content.photo_url_medium
          )
          .sort((a, b) => a.sort_order - b.sort_order)
          .slice(0, 4) || []
      }
      setContents={setContents}
    />
  );
  const youtubeBlock = (
    <SectionYoutube
      eventId={event.id}
      youtubeContents={
        contents
          .filter((content) => content.content_type === 4)
          .sort((a, b) => a.sort_order - b.sort_order) || []
      }
      setContents={setContents}
    />
  );
  const isLegacyServiceEvent = isLegacyServiceCircle(props.circle);
  const plansBlock = (
    <SectionPlans
      eventId={event.id}
      reservationSystemFee={props.reservationSystemFee}
      eventsPlans={eventsPlans}
      setEventsPlans={setEventsPlans}
      isNew={props.isNew}
      isCompanyOwnedCircle={props.isCompanyOwnedCircle}
      isReadOnly={isLegacyServiceEvent}
      circlesPlans={props.circlesPlans}
      hasPayjp={hasPayjp}
      tunagateFeeRate={props.tunagateFeeRate}
    />
  );
  const dateBlock = (
    <>
      {!event.semi_official_status && (
        <SectionDate
          event={event}
          setEvent={setEvent}
          dateAlert={dateAlert}
          eventDateError={eventDateError}
          isDateChangeProhibitionDisplay={isDateChangeProhibitionDisplay}
          isEventEndDatetimeTouched={isEventEndDatetimeTouched}
          handleEventDateInput={handleEventDateInput}
        />
      )}
    </>
  );
  const placeBlock = (
    <>
      {!event.is_online && (
        <SectionPlace
          event={event}
          setEvent={setEvent}
          setEventDateError={setEventDateError}
          placeError={placeError}
          clearSelectedPlace={() => {
            setSelectedPlace(null);
            setEvent((prev) => ({ ...prev, place: '', place_detail: '' }));
          }}
          reservationSummary={reservationSummaryState}
          onEditReservation={onEditReservation}
          onCancelReservation={() => setReservationSummaryState(null)}
        />
      )}
    </>
  );
  const onlineBlock = (
    <>
      <SectionOnline event={event} setEvent={setEvent} />
      {event.is_online && (
        <SectionUrl
          event={event}
          setEvent={setEvent}
          onlineUrlError={onlineUrlError}
          setOnlineUrlError={setOnlineUrlError}
        />
      )}
    </>
  );
  const numOfPeopleBlock = (
    <SectionNumOfPeople
      event={event}
      setEvent={setEvent}
      capacityError={capacityError}
      setPlaceError={setPlaceError}
    />
  );
  const circleBlock = (
    <>
      {event.is_new && (
        <SectionCircle
          event={event}
          setEvent={setEvent}
          usersCircles={usersCircles}
          setUsersCircles={setUsersCircles}
          circleError={circleError}
        />
      )}
    </>
  );
  const detailRowBlock = (
    <div className="container col-md-8 col-lg-6" style={{ paddingTop: 8 }}>
      <button
        type="button"
        className="tg-detail-row-open"
        onClick={openDetail}
        style={{ display: 'flex', alignItems: 'center', gap: 11, width: '100%', background: '#fff', border: '1px solid #ececee', borderRadius: 14, padding: '14px 15px', cursor: 'pointer', textAlign: 'left', boxShadow: '0 1px 2px rgba(30,30,40,.03), 0 10px 26px -16px rgba(30,30,40,.14)' }}
      >
        <span style={{ flex: 1 }}>
          <b style={{ display: 'block', fontSize: 13, fontWeight: 800, color: '#666' }}>詳細設定</b>
          <span style={{ fontSize: 11, color: '#8B9097', lineHeight: 1.4 }}>
            友達分チケット · 男女比調整 · 年齢制限 · 集合場所 · 公開範囲 · 返金ポリシー · 申込締切 · 自動送信メッセージ
          </span>
        </span>
        <span style={{ marginLeft: 'auto', color: '#8B9097', fontSize: 18 }}>›</span>
      </button>
    </div>
  );

  return (
    <div>
      <main
        className="bg-gray h-100 min-vh-100 tg-form"
        style={{ paddingBottom: '144px' }}
      >
        <style>{`
          .tg-form > section { margin-bottom: 12px; }
          .tg-form .container.col-md-8.col-lg-6 {
            max-width: 820px;
            width: 100%;
            margin-left: auto;
            margin-right: auto;
            flex: none;
          }
          .tg-detail-row-open:focus-visible {
            outline: 2px solid #FF6467;
            outline-offset: 2px;
          }
        `}</style>
        {isBasic && <StepBar current={1} setPage={setPage} />}
        {isBasic && <BasicHeading />}
        {isDetail && (
          <div className="container col-md-8 col-lg-6" style={{ paddingTop: 12 }}>
            <button
              type="button"
              onClick={() => setPage('basic')}
              style={{
                background: 'none',
                border: 'none',
                padding: 0,
                fontSize: 13,
                fontWeight: 700,
                color: '#666',
                cursor: 'pointer',
              }}
            >
              ‹ 戻る
            </button>
          </div>
        )}
        {isDetail && <StepBar current={2} setPage={setPage} />}
        {!isDetail && bannerVisible(draftSource) && (
          <DraftBanner draftSource={draftSource} aiSuggested={aiSuggested} />
        )}
        {isDetail && (
          <>
            <RemainingCard n={remainingCount} />
            <div className="container col-md-8 col-lg-6" style={{ paddingTop: 6 }}>
              <p style={{ margin: 0, fontSize: 12, color: '#8B9097', textAlign: 'center' }}>
                紹介文・主催サークルが未入力だと公開できません
              </p>
            </div>
          </>
        )}
        <ModalContentBaseXl
          ref={articleModalRef}
          previewContent={<></>}
          modalContent={
            modalPageUrl ? (
              <iframe
                title="外部ページ"
                src={modalPageUrl}
                style={{ width: '100%', height: '80vh', border: 'none' }}
              />
            ) : (
              <></>
            )
          }
        />
        {!isDetail && (
          <>
            {/* @context TGW-2677 フラグ OFF / AB の B 群は入口ページを通らないため、旧フォームには従来どおりコピー導線を置く。 */}
            {legacyHistoryButtonVisible({
              page,
              circleId: event.circle_id,
              isShowHistoryButton: props.isShowHistoryButton,
              isNew: props.isNew,
              eventIsNew: event.is_new,
            }) && <HistoryEventBtn />}
            {subjectBlock}
            {aiButtonsBlock}
            {/* @context TGW-2195 必須（イベント名・紹介文）と任意（写真・動画）が同じ強さで並び優先順位が見えなかったため、
                任意のまとまりの前に間隔と小見出しを置いて後ろへ下げる。 */}
            <div className="container col-md-8 col-lg-6" style={{ paddingTop: 32 }}>
              <p style={{ margin: '0 2px', fontSize: 12, fontWeight: 700, color: '#8B9097' }}>
                あとから追加してもOK
              </p>
            </div>
            {imageBlock}
            {youtubeBlock}
          </>
        )}
        {isDetail ? (
          <>
            {dateBlock}
            {placeBlock}
            {onlineBlock}
            {plansBlock}
            {numOfPeopleBlock}
            {circleBlock}
            <SectionRecruitUnified event={event} setEvent={setEvent} />
            {detailRowBlock}
          </>
        ) : (
          !isBasic && (
            <>
              {plansBlock}
              {dateBlock}
              {placeBlock}
              {onlineBlock}
              {numOfPeopleBlock}
              {circleBlock}
              {detailRowBlock}
              <SectionRecruitUnified event={event} setEvent={setEvent} />
            </>
          )
        )}
        {detailOpen && (
          <div style={{ position: 'fixed', inset: 0, background: '#F6F6F6', zIndex: 2000, display: 'flex', flexDirection: 'column' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 14px', borderBottom: '1px solid #ececee', background: '#fff', flex: 'none' }}>
              <button type="button" onClick={closeDetail} style={{ background: 'none', border: 'none', fontSize: 15, color: '#333', fontWeight: 600, padding: '4px 8px', cursor: 'pointer' }}>‹ 戻る</button>
              <span style={{ fontSize: 15, fontWeight: 700, color: '#333' }}>詳細設定</span>
              <button type="button" onClick={closeDetail} style={{ background: 'none', border: 'none', fontSize: 15, color: '#FF6467', fontWeight: 700, padding: '4px 8px', cursor: 'pointer' }}>完了</button>
            </div>
            <div style={{ flex: 1, overflowY: 'auto' }}>
              <style>{`
                .tg-detail .shadow-sm { box-shadow: none !important; }
                .tg-detail .bg-white { border-radius: 12px; }
                .tg-detail .bg-gray { background: #F6F6F6 !important; }
                .tg-detail select, .tg-detail input.form-control, .tg-detail textarea.form-control, .tg-detail input[type="text"], .tg-detail .form-select {
                  border: 1px solid #ececee !important;
                  border-radius: 10px !important;
                  padding: 8px 12px !important;
                }
                .tg-detail .text-black-50 { color: #666 !important; }
                .tg-detail hr { display: none; }
              `}</style>
              <div className="tg-detail" style={{ maxWidth: 820, margin: '0 auto', padding: '4px 16px 40px' }}>
                <SectionIsMultiplePurchase
                  circle={circle}
                  event={event}
                  setEvent={setEvent}
                  isNew={props.isNew}
                  multiplePurchaseError={multiplePurchaseError}
                />
                <SectionIsGenderManaged
                  circle={circle}
                  event={event}
                  setEvent={setEvent}
                  isNew={props.isNew}
                />
                <SectionIsAgeLimited
                  circle={circle}
                  event={event}
                  setEvent={setEvent}
                  isNew={props.isNew}
                />
                <ModalContentForDetail
                  props={props}
                  event={event}
                  setEvent={setEvent}
                  contents={contents}
                  setContents={setContents}
                  closeModal={closeDetail}
                  hideHeader
                  dateAlert={dateAlert}
                  eventDateError={eventDateError}
                  isDateChangeProhibitionDisplay={isDateChangeProhibitionDisplay}
                  isEventEndDatetimeTouched={isEventEndDatetimeTouched}
                  isApplicationDueDateTouched={isApplicationDueDateTouched}
                  isMeetingDatetimeTouched={isMeetingDatetimeTouched}
                  handleEventDateInput={handleEventDateInput}
                  isNewPolicyApplicable={isNewPolicyApplicable}
                />
              </div>
            </div>
          </div>
        )}

        <EventGuide />
        {isBasic ? (
          <div
            style={{
              position: 'fixed',
              left: 0,
              right: 0,
              bottom: 0,
              background: '#fff',
              borderTop: '1px solid #ececee',
              padding: '12px 16px calc(12px + env(safe-area-inset-bottom))',
              zIndex: 100,
            }}
          >
            <div style={{ maxWidth: 820, margin: '0 auto' }}>
              <button
                type="button"
                onClick={() => setPage('detail')}
                style={{
                  width: '100%',
                  padding: 14,
                  borderRadius: 40,
                  fontSize: 15.5,
                  fontWeight: 800,
                  border: 'none',
                  color: '#fff',
                  background: '#FF6467',
                  boxShadow: '0 10px 24px -10px rgba(255,100,103,.7)',
                  cursor: 'pointer',
                }}
              >
                次へ ›
              </button>
            </div>
          </div>
        ) : (
        <div
          style={{
            position: 'fixed',
            left: 0,
            right: 0,
            bottom: 0,
            background: '#fff',
            borderTop: '1px solid #ececee',
            padding: '12px 16px calc(12px + env(safe-area-inset-bottom))',
            zIndex: 100,
          }}
        >
          <div
            style={{
              maxWidth: 820,
              margin: '0 auto',
              display: 'flex',
              flexDirection: isDetail ? 'column' : 'row',
              gap: isDetail ? 8 : 10,
            }}
          >
            {!props.event?.is_participants_exists_without_creators && (
              <button
                type="button"
                value="draft"
                onClick={submitDraft}
                style={{
                  order: isDetail ? 2 : 0,
                  alignSelf: isDetail ? 'center' : 'stretch',
                  flex: isDetail ? 'none' : 1,
                  padding: isDetail ? '2px 8px' : 14,
                  borderRadius: 40,
                  fontSize: isDetail ? 13 : 15,
                  fontWeight: 800,
                  border: isDetail ? 'none' : '1.5px solid #ececee',
                  background: isDetail ? 'transparent' : '#fff',
                  color: '#666',
                  textDecoration: isDetail ? 'underline' : 'none',
                  cursor: 'pointer',
                }}
              >
                下書き保存
              </button>
            )}
            <button
              type="button"
              value="semi_official"
              onClick={submitPublic}
              style={{
                flex: isDetail ? 'none' : 1.7,
                width: isDetail ? '100%' : 'auto',
                padding: 14,
                borderRadius: 40,
                fontSize: 15.5,
                fontWeight: 800,
                border: 'none',
                color: '#fff',
                background: '#FF6467',
                boxShadow: '0 10px 24px -10px rgba(255,100,103,.7)',
                cursor: 'pointer',
              }}
            >
              公開する ›
            </button>
          </div>
        </div>

        )}
      </main>

      <ModalConfirm
        ref={modalConfirmSameEventsCreationRef}
        title="イベント作成完了"
        content="イベントを作成しました。
このイベントを来月、再来月も開催しませんか？"
        approveButtonName="続けて別日に開催する"
        rejectButtonName="開催しない"
        approveFunc={() => {
          toSameEventsCreationPage();
        }}
        rejectFunc={() => {
          toEventPage();
        }}
      />
      <ModalAlert
        ref={modalAlertNewCircleSuccessRef}
        id="modalAlertNewCircleSuccess"
        title="サークルと初めてのイベントが
          できました！"
        content="サークルとイベントの情報は後から編集できます。"
        approveFunc={() => {
          if (event.is_new && !event.semi_official_status) {
            toEventPage();
          } else {
            toEventPage();
          }
        }}
      />
      <ModalAlert
        ref={modalAlertSuccessRef}
        id="modalAlertSuccess"
        title="イベント作成完了"
        content={
          (hasSpaceReservation
            ? `イベントを作成しました。会場の予約も承りました。`
            : 'イベントを作成しました。') +
          (inviteUrlNotice ? `\n${inviteUrlNotice}` : '')
        }
        approveFunc={() => {
          if (event.is_new && !event.semi_official_status) {
            toEventPage();
          } else {
            toEventPage();
          }
        }}
      />
      <ModalAlert
        ref={modalAlertDraftSuccessRef}
        id="modalAlertDraftSuccess"
        title="下書きイベント作成完了"
        content="下書きイベントを作成しました。"
        approveFunc={() => toEventPage()}
      />
      <ModalAlert
        ref={modalAlertErrorRef}
        id="modalAlertError"
        title="イベント作成失敗"
        content={modalAlertError}
        approveFunc={() =>
          setTimeout(
            () =>
              setModalAlertError(
                'イベント作成に失敗しました。時間をおいてもう一度お試しください。'
              ),
            1000
          )
        }
      />
      <ModalAlert
        ref={modalAlertValidationErrorRef}
        id="modalAlertValidationError"
        title="イベント作成失敗"
        content="イベントが作成できません。必須項目を入力してください。"
      />
      <ModalLoader ref={modalLoaderRef} />
      <ModalConfirm
        ref={modalConfirmIsRecruitUnifiedRef}
        title="つなげーとに集客を一本化しませんか？"
        content="一本化とは、つなげーとだけで集客する、または、つなげーと外の集客においてすべてつなげーとへのリンクを貼り、このイベントページだけで参加者を募ることです。一本化することで優先的に表示されます。"
        approveButtonName="一本化する"
        rejectButtonName="しない"
        approveFunc={() => {
          const isRecruitUnified = true;
          setEvent((prev) => ({
            ...prev,
            is_recruit_unified: isRecruitUnified,
          }));
          modalConfirmIsRecruitUnifiedRef.current.closeModal();
          performPublic(isRecruitUnified);
        }}
        rejectFunc={() => {
          const isRecruitUnified = false;
          setEvent((prev) => ({
            ...prev,
            is_recruit_unified: isRecruitUnified,
          }));
          modalConfirmIsRecruitUnifiedRef.current.closeModal();
          performPublic(isRecruitUnified);
        }}
      />
    </div>
  );
};

export default Main;
